import React, { useMemo } from 'react';
import styles from '../CardRep/CardRep.module.scss';
import { useGetLearningPathInProgressQuery } from '../../LearningPaths.queries';
import FocusCardRepComponent from '../FocusCardRep/FocusCardRepComponent';
const FocusLearningPathInProgress = () => {
  const { data, isLoading } = useGetLearningPathInProgressQuery();
  const learningPath = useMemo(() => {
    return data?.learning_path;
  }, [data]);

  const completedStyles = useMemo(
    () => ({
      left: 0,
      width: `${Math.round(data?.modules_completion)}%`,
    }),
    [data]
  );
  if (isLoading) return null;

  return (
    <div className={styles.container}>
      <FocusCardRepComponent
        learningPath={learningPath}
        completedStyles_={completedStyles}
        completed={2}
        module_completion={data?.modules_completion}
      />
    </div>
  );
};

export default FocusLearningPathInProgress;
